<template>
  <div class="teaching-evaluate-statistics">
    <PlatDataGridSemester grid-id="PeTchEvaluationQuery"
                          show-label></PlatDataGridSemester>
  </div>
</template>

<script>
import PlatDataGridSemester from '../../../wrapper/grid/PlatDataGridSemester'
export default {
  name: 'TeachingEvaluateStatistics',
  components: {
    PlatDataGridSemester
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-statistics {
    height: 100%;
  }
</style>
